import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
// import "../../index.css";
import { useSnackbar } from "notistack";
import axiosInstance from "../../axiosInstance";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";

const SitesList = (props) => {
  const { enqueueSnackbar } = useSnackbar();
  const [data, setData] = React.useState([]);
  const [showSiteData, setShowSiteData] = React.useState([]);
  const [loading, setLoading] = React.useState(false);

  async function fetchData() {
    setLoading(true);
    try {
      let response = await axiosInstance.get(`/api/admin/all-sites`);

      setData(response.data.data);
      // console.log(response.data);
    } catch (err) {
    } finally {
      setLoading(false);
    }
  }

  React.useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="w-full p-4 flex flex-row">
      {loading ? (
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", mt: 4, gap: 1, width: "100%" }}>
          <CircularProgress />
          <span style={{ color: "#666" }}>Loading sites...</span>
        </Box>
      ) : data.length === 0 ? (
        <Box sx={{ display: "flex", justifyContent: "center", mt: 4, color: "#666", width: "100%" }}>
          No sites found.
        </Box>
      ) : (
      <div className=" font-medium bg-white overflow-x-auto h-[calc(100vh-100px)]">
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
            <TableHead>
              <TableRow className="p-2">
                <TableCell>Site Id</TableCell>
                <TableCell>Site Url</TableCell>
                <TableCell>User</TableCell>
                <TableCell>Custom Code</TableCell>
                <TableCell>Subscription</TableCell>
                <TableCell>Created On</TableCell>
                <TableCell>Updategd On</TableCell>
                <TableCell>isPublished</TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((row: any, idx: any) => {
                const created_date = new Date(row.createdAt);
                const updated_date = new Date(row.updatedAt);
                const { siteUrl, subDomain } = row;
                let updatedUrl = siteUrl;

                if (siteUrl && subDomain) {
                  const parts = siteUrl.split(".");
                  if (parts.length >= 1 && parts[0] !== subDomain) {
                    parts[0] = subDomain;
                    updatedUrl = parts.join(".");
                  }
                }

                return (
                  <TableRow
                    key={idx}
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell component="th" scope="row">
                      {row.siteId}
                    </TableCell>

                    <TableCell component="th" scope="row">
                      <a href={`https://${updatedUrl}`} target="_blank">{updatedUrl}</a>
                    </TableCell>

                    <TableCell component="th" scope="row">
                      {row.email}
                    </TableCell>

                    <TableCell component="th" scope="row">
                      {row.customCode}
                    </TableCell>

                    <TableCell component="th" scope="row">
                      {row.subscriptionStatus}
                    </TableCell>

                    <TableCell component="th" scope="row">
                      {created_date.toLocaleString()}
                    </TableCell>

                    <TableCell component="th" scope="row">
                      {updated_date.toLocaleString()}
                    </TableCell>

                    <TableCell component="th" scope="row">
                      {row.isPublished ? "true" : "false"}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      )}
    </div>
  );
};

export default SitesList;
